import React, { useState, useRef } from 'react';

function AudioProcessorWorklet() {
  const [audioFile, setAudioFile] = useState(null);
  const [waitTime, setWaitTime] = useState(0);
  const audioContextRef = useRef(null);
  const sourceRef = useRef(null);
  const workletNodeRef = useRef(null);

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    setAudioFile(URL.createObjectURL(file));
  };

  const handlePlay = async () => {
    if (!audioFile) return;

    if (!audioContextRef.current) {
      audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)();
    }

    const audioContext = audioContextRef.current;

    const response = await fetch(audioFile);
    const arrayBuffer = await response.arrayBuffer();
    const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);

    if (sourceRef.current) {
      sourceRef.current.disconnect();
      workletNodeRef.current.disconnect();
    }

    await audioContext.audioWorklet.addModule('/my-audio-processor.js');

    const source = audioContext.createBufferSource();
    source.buffer = audioBuffer;

    const workletNode = new AudioWorkletNode(audioContext, 'my-audio-processor', {
      parameterData: { waitTime: waitTime }
    });

    source.connect(workletNode);
    workletNode.connect(audioContext.destination);
    source.start(0);

    sourceRef.current = source;
    workletNodeRef.current = workletNode;
  };

  return (
    <div>
      <input type="file" accept="audio/*" onChange={handleFileUpload} />
      <input
        type="number"
        value={waitTime}
        onChange={(e) => setWaitTime(Number(e.target.value))}
        placeholder="Wait time (ms)"
      />
      <button onClick={handlePlay}>再生</button>
    </div>
  );
}

export default AudioProcessorWorklet;
